import { atom } from "~/observers/jotai";

export const corporalEvaluationImageAtom = atom<number>(0);
